import React, { useLayoutEffect } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { SBUModel } from "../../models/SBUModel";

type Props = {
  data: [];
  allSbus: SBUModel[];
};
const StackedWaterfallChart = (props: Props) => {
  let i = 1;
  useLayoutEffect(() => {
    var root = am5.Root.new("stackedWaterfalldiv");
    root.setThemes([am5themes_Animated.new(root)]);

    /* remove amchart logo */
    root._logo?.dispose();

    // Create chart
    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        wheelX: "panX",
        wheelY: "zoomX",
        layout: root.verticalLayout,
      })
    );
    chart.children.unshift(
      am5.Label.new(root, {
        text: "Win-Loss FY-YTD",
        fontWeight: "600",
        textAlign: "center",
        x: am5.percent(50),
        centerX: am5.percent(100),
      })
    );

    // Create axes
    var xRenderer = am5xy.AxisRendererX.new(root, {
      cellStartLocation: 0.1,
      cellEndLocation: 0.9,
      minGridDistance: 70,
    });

    var xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        maxDeviation: 0,
        categoryField: "category",
        maxWidth: 1000,
        renderer: xRenderer,
        tooltip: am5.Tooltip.new(root, {}),
      })
    );

    xAxis.labelsContainer.set(
      "tooltip",
      am5.Tooltip.new(root, {
        pointerOrientation: "up",
      })
    );
    xAxis.get("renderer").labels.template.setAll({
      oversizedBehavior: "wrap",
      maxWidth: 80,
      textAlign: "center",
      fontSize: "10px",
      tooltipText: "{category}",
    });

    xRenderer.labels.template.setup = function (target: any) {
      target.set(
        "background",
        am5.Rectangle.new(root, {
          fill: am5.color(0x000000),
          fillOpacity: 0,
        })
      );
    };

    xRenderer.grid.template.setAll({
      location: 1,
    });

    xAxis.data.setAll(props.data);

    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        numberFormat: "#.a",
        calculateTotals: true,
        extraMax: 0.05,
        renderer: am5xy.AxisRendererY.new(root, {
          strokeOpacity: 0.1,
        }),
      })
    );

    // Add series
    function makeSeries(
      name: any,
      field: any,
      openField: any,
      index: number,
      total: any,
      color: any
    ) {
      let series = chart.series.push(
        am5xy.ColumnSeries.new(root, {
          name: name,
          xAxis: xAxis,
          yAxis: yAxis,
          valueYField: field,
          openValueYField: openField,
          categoryXField: "category",
          clustered: false,
          fill: color,
          stroke: color,
        })
      );

      series.columns.template.setAll({
        tooltipText: `{name}, #: {count${index}}, INR {difference} Cr`,
        width: am5.percent(40),
        tooltipY: 0,
      });

      series.data.setAll(props.data);

      // Calculate the difference and add it to the tooltip
      series.columns.template.adapters.add(
        "tooltipText",
        function (text: any, target: any) {
          const valueY = target.dataItem.get("valueY");
          const openValueY = target.dataItem.get("openValueY");
          const difference = valueY - openValueY;
          return text.replace("{difference}", difference.toLocaleString());
        }
      );
      // Make stuff animate on load
      series.appear();

      series.bullets.push(function () {
        let label = am5.Label.new(root, {
          // text: "{valueY}",
          fill: root.interfaceColors.get("alternativeText"),
          centerY: am5.p50,
          centerX: am5.p50,
          populateText: true,
          textAlign: "center",
          oversizedBehavior: "hide",
        });

        // label.adapters.add("text", function (text, target) {
        //   let val = Math.abs(
        //     target.dataItem.get("valueY") - target.dataItem.get("openValueY")
        //   );
        //   return val;
        // });

        return am5.Bullet.new(root, {
          locationX: 0.5,
          locationY: 0.5,
          sprite: label,
        });
      });

      if (total) {
        series.bullets.push(function () {
          let totalLabel = am5.Label.new(root, {
            text: "{valueY}",
            fill: root.interfaceColors.get("text"),
            centerY: am5.p100,
            centerX: am5.p50,
            populateText: true,
            textAlign: "center",
          });

          // totalLabel.adapters.add("text", function (text, target) {
          //   var dataContext = target.dataItem.dataContext;
          //   var val = Math.abs(dataContext.close2 - dataContext.open1);
          //   return val;
          // });

          return am5.Bullet.new(root, {
            locationX: 0.5,
            locationY: 1,
            sprite: totalLabel,
          });
        });
      }
    }

    var colorSet = am5.ColorSet.new(root, {});
    let j = 1;

    props.allSbus.forEach((sbu) => {
      makeSeries(
        sbu.name,
        `close${i}`,
        `open${i}`,
        i,
        false,
        colorSet.getIndex(j)
      );
      i++;
      j = j + 2;
    });

    // Make stuff animate on load
    chart.appear(1000, 100);

    return () => {
      // Clean up any resources or event listeners here
      root.dispose();
    };
  });

  return (
    <div
      id="stackedWaterfalldiv"
      style={{ width: "100%", height: "100%" }}
    ></div>
  );
};

export default StackedWaterfallChart;
